import React, { forwardRef } from 'react'
import { Input } from '@chakra-ui/react'

export const CustomInput = forwardRef((props, ref) => {
  return (
    <Input
      outline="none"
      ref={ref}
      color="brand.textBlue"
      fontSize="14px"
      _placeholder={{
        fontSize: '13px',
      }}
      _focus={{
        borderColor: 'brand.brightBlue',
      }}
      {...props}
    />
  )
})

CustomInput.propTypes = {}
